import { ApiProperty } from '@nestjs/swagger'
import { IsString, Matches } from 'class-validator'

export class ValidateEmailAttemptDTO {
    @ApiProperty({ example: 'DEAD0-BEEF0-CAFE0-BABE0' })
    @IsString()
    @Matches(/[0-9a-fA-F]{5}-[0-9a-fA-F]{5}-[0-9a-fA-F]{5}-[0-9a-fA-F]{5}/, { message: 'Invalid code.' })
    code: string
}
